// extracted by mini-css-extract-plugin
export default {"mainContent":"NotFoundPage_mainContent__0ZL95","container":"NotFoundPage_container__caiQc","error":"NotFoundPage_error__dvKs3","icon":"NotFoundPage_icon__vu-QX"};